<template>

    <b-container class="container-about-application">
        <b-row class="mb-20 about-title">
            О приложении
        </b-row>

        <b-row class="mb-20 about-text">
            Приложение для сотрудников ООО МАЙ ФУДС.
        </b-row>

        <b-row class="mb-20 about-text">
           Приложение предназначено для автоматизации розничного аудита торговых точек, 
           контроля уровня мерчандайзинга и обученности торгового персонала, выполнения корпоративных стандартов, 
           проведения store check анализа и других полевых активностей. Приложение также позволяет в автоматическом режиме собирать 
           оперативную обратную связь, отслеживать качество сервиса компании, индексы эффективности и другие KPI.
        </b-row>

        <b-row class="mb-20 about-text">
            Приложение позволяет эффективно собирать и фиксировать всю необходимую информацию, работать со всей базой торговых точек, 
            как прямых продаж, так и дистрибьюторской сети, а также позволяет быстро получить ключевую информацию по любой точке 
            и различную справочную информацию, такую как стандарты представленности, каталог продукции и прочее.      
        </b-row>

        <b-row class="mb-20 about-text">
            Об ошибках, пожалуйста, пишите нам: <a href="mailto:support-may@devs-universe.com">support-may@devs-universe.com</a>
        </b-row>

        <b-row class="mb-20 about-text">
            Или звоните по телефону: +7 925 477-6778
        </b-row>

    </b-container>

</template>
<script>
import '@/assets/styles/client/about/about.css'

export default {
    
}
</script>